import { FileKind } from "../../../../define/FileKind";
import { BaseLocalListData } from "../../base/BaseLocalListData";

/** 城市数据 */
class CityData{
    /** 城市唯一id */
    id: string = '';
    /** 当前镇守的武将id */
    officerId: string = '';
    /** 是否丢失中 */
    bDrop: boolean = false;
    /** 最后领取收益日期 */
    lastRecvAwardTime: number = 0;
    /** 最后计算丢城事件日期 */
    lastDropTime: number = 0;
}

export default class MilitaryCityData extends BaseLocalListData {
    lists = new Map<string, CityData>();

    /** 城池收益 */
    earningGoods: string[] = [];
    earningGoodsCount: number[] = [];

    /** 是否第一次购买城池 */
    bFirstBuy: boolean = false;
   
    protected localKey: string = FileKind.SaveLocalDataKey.MILITARY_CITY_DATA;

    createItem(key: string): CityData {
        return this.createItemT<CityData>(CityData, key);
    }
}
